const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CategoryRestrictionCommand: any = {
    SaveCategoryRestrictions: Backofficebff + '/v1/category-restriction',
};
